const APP_ENV = process.env.REACT_APP_ENV || "development";

const LOGIE_WEBSITE = "https://logie.logcluster.org";

export const LOG_CLUSTER_LANGUAGES = ["en", "fr", "es", "pt"];

export const ORS_WAY_TYPES = Object.freeze({
  0: {
    name: "Unknown",
    tags: [],
  },
  1: {
    name: "State Road",
    tags: [
      "primary",
      "primary_link",
      "motorway",
      "motorway_link",
      "trunk",
      "trunk_link",
    ],
  },
  2: {
    name: "Road",
    tags: [
      "secondary",
      "secondary_link",
      "tertiary",
      "tertiary_link",
      "road",
      "unclassified",
    ],
  },
  3: {
    name: "Street",
    tags: ["residential", "service", "living_street"],
  },
  4: {
    name: "Path",
    tags: ["path"],
  },
  5: {
    name: "Track",
    tags: ["track"],
  },
  6: {
    name: "Cycleway",
    tags: ["cycleway"],
  },
  7: {
    name: "Footway",
    tags: ["footway", "pedestrian", "crossing"],
  },
  8: {
    name: "Steps",
    tags: ["steps"],
  },
  9: {
    name: "Ferry",
    tags: ["route=shuttle_train", "route=ferry"],
  },
  10: {
    name: "Construction",
    tags: ["construction"],
  },
});

export const ORS_SURFACE_TYPES = Object.freeze({
  0: {
    name: "Unknown",
    tags: [],
  },
  1: {
    name: "Paved",
    tags: ["paved"],
  },
  2: {
    name: "Unpaved",
    tags: ["unpaved", "woodchips", "rock", "rocks", "stone", "shells", "salt"],
  },
  3: {
    name: "Asphalt",
    tags: ["asphalt", "chipseal", "bitmac", "tarmac"],
  },
  4: {
    name: "Concrete",
    tags: ["concrete", "cement"],
  },
  5: {
    name: "Cobblestone",
    tags: [],
  },
  6: {
    name: "Metal",
    tags: ["metal"],
  },
  7: {
    name: "Wood",
    tags: ["wood"],
  },
  8: {
    name: "Compacted Gravel",
    tags: ["compacted", "pebblestone"],
  },
  9: {
    name: "Fine Gravel",
    tags: [],
  },
  10: {
    name: "Gravel",
    tags: ["gravel", "fine_gravel"],
  },
  11: {
    name: "Dirt",
    tags: ["dirt", "earth", "soil"],
  },
  12: {
    name: "Ground",
    tags: ["ground", "mud"],
  },
  13: {
    name: "Ice",
    tags: ["ice", "snow"],
  },
  14: {
    name: "Paving Stones",
    tags: [
      "paving_stones",
      "paved_stones",
      "sett",
      "cobblestone",
      "unhewn_cobblestone",
      "bricks",
      "brick",
    ],
  },
  15: {
    name: "Sand",
    tags: ["sand"],
  },
  16: {
    name: "Woodchips",
    tags: ["woodchips"],
  },
  17: {
    name: "Grass",
    tags: ["grass"],
  },
  18: {
    name: "Grass Paver",
    tags: ["grass_paver"],
  },
});

export const ORS_TO_LOGIE_ROAD_TYPES = Object.freeze({
  0: 0,
  1: 2,
  2: 3,
  3: 5,
  4: 7,
  5: 7,
  6: 6,
  7: 6,
  8: 6,
  9: 0,
  10: 0,
});

const LANGUAGES = {
  en: {
    title: "English",
    displayCode: "en",
  },
  fr: {
    title: "Français",
    displayCode: "fr",
  },
  es: {
    title: "Español",
    displayCode: "es",
  },
  ar: {
    title: "عربى",
    displayCode: "ar",
  },
  zh: {
    title: "中国人",
    displayCode: "zh",
  },
  ru: {
    title: "Pусский",
    displayCode: "ru",
  },
  tr: {
    title: "Türkçe",
    displayCode: "tr",
  },
  pt: {
    title: "Português",
    displayCode: "pt",
  },
};

export { APP_ENV, LANGUAGES, LOGIE_WEBSITE };

export const LineSymbol = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="22">
    <defs></defs>
    <g transform="matrix(1,0,0,1,0,1.7763568394002505e-15)">
      {props.dash ? (
        <path
          fill="none"
          fillRule="evenodd"
          strokeWidth={5}
          stroke={props.stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="8"
          strokeMiterlimit="8"
          d="M 11 11 L 39 11"
        ></path>
      ) : (
        <path
          fill="none"
          fillRule="evenodd"
          stroke={props.stroke}
          strokeWidth="22"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="none"
          strokeMiterlimit="4"
          d="M 11 11 L 39 11"
        ></path>
      )}
    </g>
  </svg>
);

export const basemapZooms = {
  af5012f54b2b49508a9231d009fb1669: {
    title: "Topographic Map",
    minZoom: 3,
    zoom: 0,
  },
  fe95023e8d0d44b4bb067b2bece8a63c: {
    title: "Topographic Map",
    minZoom: 3,
    zoom: 0,
  },
  "4bb1ab1e1f0844029b211f2edf9426f4": {
    title: "Light Gray Map",
    minZoom: 2,
    zoom: -1,
  },
  f529d5be814a4d989d105c73242fe48a: {
    title: "Dark Mode Map",
    minZoom: 2,
    zoom: -1,
  },
  "7395932867e24688b8ddbc28c4856d6a": {
    title: "Satellite Imagery Map",
    minZoom: 3,
    zoom: -1,
  },
};

export const ISO3_FIELDS = ["iso3", "iso3a", "iso3b", "iso3c"];
